import React, { FC } from 'react';
import classnames from 'classnames';

import { IDynamicComponent, IComponentParams } from 'plugins/api/types';

import { DynamicSwitchComponent } from 'plugins/components/containers';

import 'plugins/theme/components/ListPanel/ListPanel.scss';

// typ danych wejściowych
interface IProps {
  pageSymbol: string;
  components?: IDynamicComponent[];
  requestParams?: object;
  horizontal?: boolean;
  componentParams?: IComponentParams;
}

const ListPanel: FC<IProps> = ({
  pageSymbol,
  components,
  requestParams,
  horizontal,
  componentParams
}) => {
  return (
    <div className={classnames('ListPanel', horizontal && 'ListPanel-Horizontal')}>
      <DynamicSwitchComponent
        components={components}
        pageSymbol={pageSymbol}
        requestParams={requestParams}
        horizontal={horizontal}
        componentParams={componentParams}
      />
    </div>
  );
};

export default ListPanel;
